import React from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { SpinnerCircularFixed } from "spinners-react";
import {
  updateSelectedSchedule,
  updateSelectedPropValues,
  showTagsCatsList,
  showMetaPropTagList,
} from "../../../helpers/actions/Action";
import { useState } from "react";
import { HOST_URL } from "../../../helpers/constants/Constants";
import { ScheduleCategories } from "../ScheduleCategories";
import store from "../../../helpers/store/Store";

const SapSchedule = (props) => {
  const userData = useSelector((state) => state.requestUserDataReducer.data);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const selectedProject = useSelector(
    (state) => state.getSelectedProjectReducer.data
  );
  const selectedModel = useSelector(
    (state) => state.getSelectedModelReducer.data
  );
  const handleSubmitButtonClick = (e) => {
    axios({
      method: "Post",
      url: HOST_URL + "/api/workflow/submit?id=" + e.target.value,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        console.log("response =", response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const resetSchedule = () => {
    //quickSave();
    store.dispatch(updateSelectedSchedule(""));
    store.dispatch(updateSelectedPropValues([]));
    store.dispatch(showTagsCatsList(false));
    store.dispatch(showMetaPropTagList(false));
  };

  const handleGenrateReportButtonClick = (ele) => {
    if (selectedProject.text === "") {
      alert("Project name not found");
      return;
    }
    if (selectedModel.fileName === "") {
      alert("Selected File Could Not Be Found");
      return;
    }
    // if (dataIsSaved === false) {
    //   alert("Please save your data first");
    //   return;
    // }

    setIsSubmitting(true);
    var scheduleType = "sap";
    console.log(selectedModel.fileName);
    var formData = new FormData();
    formData.append("ProjectName", selectedProject.text);
    formData.append("ScheduleType", scheduleType);
    formData.append("ScheduleCategories", JSON.stringify(ScheduleCategories));
    formData.append("FileName", selectedModel.fileName);

    // var fileName = selectedProject.text + "_" + scheduleType + ".xlsx";
    axios.defaults.withCredentials = true;
    axios({
      method: "post",
      url: HOST_URL + `/api/getsapreport`,
      data: formData,
      responseType: "blob",
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        setIsSubmitting(false);
        alert("Schedule saved to BIM 360");
      })
      .catch((error) => {
        console.log(error);
        alert("An Error Occured: " + error);
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <div className="col-11">
              <h2 id="pageModalLabel" style={{ fontWeight: "bold" }}>
                Sap Schedule for {props.project.text}
              </h2>
            </div>
            <div className="col-1">
              <button
                type="button"
                className="close"
                onClick={resetSchedule}
                data-dismiss="modal"
                data-keyboard="true"
                aria-label="Close"></button>
            </div>
          </div>
          <div className="modal-body">
            <div>
              <div className="row">
                <div
                  className="col-12"
                  style={{ height: "90vh", overflow: "auto" }}>
                  <div
                    className="row"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      paddingBottom: "20px",
                    }}>
                    <button
                      type="button"
                      className="btn btn-lg btn-primary"
                      onClick={handleGenrateReportButtonClick}>
                      <SpinnerCircularFixed
                        size={20}
                        thickness={180}
                        speed={140}
                        enabled={isSubmitting}
                        color="rgba(0, 114, 188, 1)"
                        secondaryColor="rgba(0, 0, 0, 0.92)"
                      />
                      {isSubmitting ? (
                        <span>Submitting...</span>
                      ) : (
                        <span>Submit to BIM360</span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SapSchedule;
